// extracted by mini-css-extract-plugin
export var floatingHero = "style-mod--floating-hero--d3e9a";
export var floatingHeroDescription = "style-mod--floating-hero-description--42685";
export var floatingHeroImage = "style-mod--floating-hero-image--8bb4b";
export var floatingHeroImageMobile = "style-mod--floating-hero-image-mobile--5a3a5";
export var floatingHeroParagraph = "style-mod--floating-hero-paragraph--5047c";
export var floatingHeroParagraphMobile = "style-mod--floating-hero-paragraph-mobile--eec91";
export var mainTitle = "style-mod--main-title--7fdd8";